import React from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom'
import hero1 from '../../images/slider/slide-1.jpg'
import hero2 from '../../images/slider/slide-2.jpg'


const Hero = () => {
    return (

        <section className="wpo-hero-slider" >
            <Swiper
                // install Swiper modules
                modules={[Navigation, A11y , ]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={800}
                parallax={true}
                autoplay={true}
                navigation
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero1})` }}>
                        <div className="container">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>Welcome to <br/> YATRI INTERIORS </h2>
                                </div>
                                <div className="slide-text">
                                    <p>Your trusted partner for 
                                    innovative and functional interior solutions in Bengaluru.</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns">
                                    <Link to="/contact" className="theme-btn">Contact Us </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero2})` }}>
                        <div className="container">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2> Crafting Interiors with <br/> Precision and Passion </h2>
                                </div>
                                <div className="slide-text">
                                    <p>At YATRI INTERIORS, we believe that every space tells 
                                    a story — of dreams, utility, and identity. </p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns">
                                    
                                    <a href="tel:9663222146" className="theme-btn">Call Now : +91 96632 22146</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                ...
            </Swiper>
        </section>
    )
}

export default Hero;